<template>
  <StandardEquipmentsTable />
</template>

<script>
import StandardEquipmentsTable from './components/StandardEquipmentsTable.vue'

export default {
  components: {
    StandardEquipmentsTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
</script>
